(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider'];

    function httpConfig($urlRouterProvider, $httpProvider) {

        $urlRouterProvider.otherwise('/login');

        $httpProvider.defaults.withCredentials = true;
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('globalErrorInterceptor');
        $httpProvider.interceptors.push('dataLoadedInterceptor');
        $httpProvider.interceptors.push('modalWaitInterceptor');
    }
})();
